import { reactive } from 'vue';
export const appState = reactive({
    locationId: '',
    userId: '',
    tokenId: '',
    chatWidgetId: '',
    chatWidgetName: '',
    chatWidgetSettingsData: {},
    unsavedChanges: false,
    updatedAt: undefined,
    customFields: [],
    waNumbers: [],
    locale: '',
    timeZone: '',
    locationCountryCode: '',
    errorInDurationPickerMap: {
        slotInterval: false,
        slotDuration: false,
        slotBuffer: false,
        preBuffer: false,
    },
    levelUpCompany: false,
    getCodeButtonDisabled: false,
});
